import { Component, Inject } from '@angular/core';
import { EffectiveWeek } from '../../merger/annual-plan-data-merger';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import { SecondsToDHMPipe } from "../../../common/pipes/seconds-to-DHM-pipe";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { DefaultPipe } from "../../../common/pipes/default";
import { TranslateModule } from "@ngx-translate/core";
import { NgForOf, NgIf, NgStyle } from "@angular/common";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-effective-plan-graph-dialog',
  templateUrl: './effective-plan-graph-dialog.component.html',
  styleUrls: ['./effective-plan-graph-dialog.scss'],
  imports: [
    SecondsToDHMPipe,
    AppDatePipe,
    DefaultPipe,
    TranslateModule,
    MatDialogContent,
    MatDialogClose,
    MatDialogActions,
    MatDialogTitle,
    NgForOf,
    NgIf,
    MatButton,
    NgStyle,
  ],
  standalone: true
})
export class EffectivePlanGraphDialogComponent {
    public week: EffectiveWeek;

    constructor(
        public dialogRef: MatDialogRef<EffectivePlanGraphDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.week = data.week;
    }
}
